import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { LoaderContext } from 'contexts/loader-context'
import { useSession } from 'contexts/session-context'
import { useContext, useEffect, useState } from 'react'
import useRouter from 'hooks/use-router'
import { SurveyTypeEnum } from 'contexts/survey-context/survey.interface'
import { useSurvey } from 'contexts/survey-context/useSurvey'
import { useRouteMatch } from 'react-router-dom'
import { AxiosError } from 'axios'
import LoadingScreen from 'components/loading-screen'
import useMainClass, { usePopupContext } from 'hooks/use-main-cass'
import useRedirect from 'hooks/use-redirect'
import CONFIGS from 'build/Config'
// import ExchangeComponent from 'components/exchange'
import { shouldShowOnboarding } from 'utilities/onboardingTime'
import OnboardingStep from 'components/onboarding-steps'
import { PrizesCouponType } from 'types/prizes.d'
import PopUpExchangeV2 from 'components/exchange/popUpExchange'
import SurveyPolaris from './components/surveyPolaris'
import PopUpError from './components/popUpError'
import DemandSpaceComponent from './components/demandSpace'
import PostalCode from './components/postalCode'
// import SurveyStepper from './components/surveyStepper'

interface IProps {
  isDirectAccess?: boolean
}

function Survey({ isDirectAccess = false }: IProps) {
  const { setLoad } = useContext(LoaderContext)
  const [{ data }] = useSession()
  const { push } = useRouter()
  const route = useRouteMatch<{ id: string }>()
  const { query }: { query: { redirect?: string; actionType?: SurveyTypeEnum; id?: number } } = useRouter()
  const [{ url }] = useRedirect()
  const [{ state, surveyLoading }, { updatePolarisSurvey, validateSurvey, resetSurvey }] = useSurvey()
  useMainClass('survey')
  const redirect = () => {
    resetSurvey()
    return push(
      state?.survey?.redirectUrl === '' || !state?.survey?.redirectUrl
        ? query?.redirect ?? url ?? '/home'
        : state?.survey?.redirectUrl
    )
  }

  const { openPopup, closePopup } = usePopupContext()

  const handleSubmit = async (callback: () => Promise<void>) => {
    setLoad(true)
    try {
      await callback()
    } catch (error) {
      const err = error as AxiosError
      resetSurvey()
      return push(`/error/${err?.response?.data?.code ?? 99999}`)
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    const fetchSurvey = async () => {
      await validateSurvey(route.params.id, isDirectAccess)
    }
    if (data) {
      fetchSurvey()
    }
  }, [])

  useEffect(() => {
    if (state.prize) {
      const points = state.prize?.points
      const title = state.prize?.title
      let description = `Ya estás participando para obtener la ${points ? `${points} ${POINTS_NAME}` : title}. Quédate atento a tu correo para saber si estás entre los ganadores. Recuerda que solo podrás asistir con una invitación.`

      if ((state.prize as any)?.couponTypeId === PrizesCouponType.STICKER) {
        description = `Gracias por contestar. ${points} ${POINTS_NAME}. Consigues el sello ${title}.`
      }

      if (state?.survey?.id === 14) {
        description = `¡Gracias por tu opinión! 🎉 Ya estas participando por Hielera o Amazon Gift card de 1,000 MXN. Mantente atento a tu correo/WhatsApp para conocer si eres ganador.`
      }

      openPopup(
        <PopUpExchangeV2
          description={description}
          buttons={{
            handleButtonCommon() {
              gtag('event', 'event_to_ga', {
                event_category: 'Survey',
                event_label: state?.survey?.buttonText ?? textServices.findByText('survey/exchange/button/text', 'VER MIS PREMIOS'),
                value: state?.survey?.id
              })
              dlTrackEvent('user_interaction', {
                action: 'click',
                element: state?.survey?.buttonText ?? textServices.findByText('survey/exchange/button/text', 'VER MIS PREMIOS'),
                section: `survey :: ${state?.survey?.id}`
              })
              closePopup()
              redirect()
            },
            handleButtonSticker() {
              gtag('event', 'event_to_ga', {
                event_category: 'Survey',
                event_label: state?.survey?.buttonText ?? textServices.findByText('survey/exchange/button/text', 'VER MIS SELLOS'),
                value: state?.survey?.id
              })
              dlTrackEvent('user_interaction', {
                action: 'click',
                element: textServices.findByText('survey/exchange/button/text', 'VER MIS SELLOS'),
                section: `survey :: ${state?.survey?.id}`
              })
              closePopup()
              redirect()
            },
            text: state?.survey?.buttonText ?? textServices.findByText('survey/exchange/button/text', 'VER MIS PREMIOS'),
          }}
          buttonSecondary={{
            text: '',
            url: '',
            hidden: true
          }}
          item={state?.prize}
          useRanking={false}
        />
      )
    }
  }, [state.prize])


  useEffect(() => {
    if (state?.error) {
      // if is not direct access, redirect to default page to avoid show error page
      if (!isDirectAccess) {
        redirect()
      }
      openPopup(<PopUpError errorCode={state?.error} />)
    }

  }, [state?.error])

  const v2 = CONFIGS.versionPh === 'v2'

  const [onboarding, setOnboarding] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  const toggleOnboarding = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: onboarding ? 'close onboarding' : 'open onboarding',
      section: 'trivias :: onboarding'
    })
    setOnboarding(!onboarding)
  }

  useEffect(() => {
    if (!hasChecked) {
      const showOnboarding = shouldShowOnboarding('survey-onboarding');
      setOnboarding(showOnboarding);
      setHasChecked(true);
    }
  }, [hasChecked]);

  const steps = [
    {
      // image: `${AZURE_BASE_URL}/survey_complete_profile.webp`,
      title: 'Completa tu perfil',
      subtitle: 'Termina de armar tu cuenta con tus datos personales.'
    },
    {
      // image: `${AZURE_BASE_URL}/survey_answer_questions.webp`,
      title: 'Contesta las preguntas',
      subtitle: 'y estarás participando por una invitación a la fiesta. Quédate atento a tu correo para saber si ganaste. Recuerda que solo se podrá asistir con una invitación al evento. '
    }
  ]

  if (onboarding && v2 && !isDirectAccess) {
    return (
      <OnboardingStep
        title="¿CÓMO PARTICIPAR?"
        subtitle="RESPONDE Y GANA"
        close={toggleOnboarding}
        steps={steps}
      />
    )
  }

  if (state?.demandSpace)
    return <DemandSpaceComponent demandSpace={state?.demandSpace} redirect={redirect} surveyInfo={state?.surveyInfo} />

  if (surveyLoading) return <LoadingScreen />

  if (state?.survey?.encuestaType === 'Normal' && state.survey?.isAnswered && (state?.survey?.viewType !== 'Steps' || THEME !== 'indio')) return <>{redirect()}</>

  if (state?.survey?.viewType === 'Steps') {
    return (
      <PostalCode
        redirect={redirect}
        title={state?.survey?.name}
        id={state?.survey?.id}
        questions={state?.survey?.questions}
        handleSubmit={handleSubmit}
        updatePolarisSurvey={updatePolarisSurvey}
      />
    )
  }

  // if (state?.survey?.viewType === 'Steps') return (
  //   <SurveyStepper
  //     survey={state?.survey}
  //     updatePolarisSurvey={updatePolarisSurvey}
  //     resetSurvey={resetSurvey}
  //     redirect={redirect}
  //   />
  // )

  return (
    <SurveyPolaris
      title={state?.survey?.name}
      prize={state?.survey?.prize}
      id={state?.survey?.id}
      questions={state?.survey?.questions}
      handleSubmit={handleSubmit}
      updatePolarisSurvey={updatePolarisSurvey}
      redirect={redirect}
      isOptional={state?.survey?.optional}
    />
  )
}

export default Survey
